// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__1FQBh","altError":"Error_altError__1pshh"};